import { gql } from "apollo-boost";

/* 
 *  extend type Query {
 *    getExamsByFilter
 *      : [Exam]
 *  }
 */
export const GET_EXAM_LIST_BYFILTER = gql`
  query getExamsByFilter($examFilterInput: ExamFilterInput) {
    getExamsByFilter(
      examFilterInput: $examFilterInput
    )
    {
      id
      subjectGroup {
        id
      }
      subject {
        id
      }
      teacher {
        id
      }
    }
  }
`;
